export default {
  menu: {
    settings: "Settings",
    profile: "Profile",
    teams: "Teams",
    security: "Security",
    orders: "Orders",
    api: "API",
    custom_domains: "Custom Domains",
    custom_pixel_scripts: "Custom Pixel Scripts",
    branded_domains: "Branded Domains",
    billing: "Billing",
    subscription: "Subscription",
    payment_method: "Payment Method",
    invoices: "Invoices",
    billing_and_payment: "Billing & Payment",
    log_out: "Log Out",
    usage: "Account Usage",
    custom_pixel: "Custom Pixel Scripts",
  },

  title: {
    plan_options: "Plan options",
    select_plan: "Find a plan that meets your needs",
  },

  billing: {
    subscription: {
      default: {
        title: "Custom",
        name: "Custom",
        description: {
          long: "With a custom subscription, you have the freedom to choose the features and services that matter most to you, and only pay for what you need.",
          short: "tailored to your unique needs and preferences.",
        },
      },
      free: {
        title: "Free",
        name: "Free",
        description: {
          long: "Free basic ad-supported shortening for individual users. Customize your links and keep track of your link history.",
          short: "basic ad-supported shortening for individual users.",
        },
      },
      pro: {
        title: "Pro",
        description: {
          long: "Go Pro to take your branded links to the next level, with unlimited tracked clicks, link tagging, URL editing, and more.",
          short: "to take your brand to the next level.",
        },
      },
      pro5k: {
        title: "Pro 5K",
        description: {
          long: "Go Pro to take your branded links to the next level, with unlimited tracked clicks, link tagging, URL editing, and more.",
          short: "to take your brand to the next level.",
        },
      },
      pro50k: {
        title: "Pro 50K",
        description: {
          long: "Go Pro to take your branded links to the next level, with unlimited tracked clicks, link tagging, URL editing, and more.",
          short: "to take your brand to the next level.",
        },
      },
      bulk: {
        title: "Bulk API Link Shortening",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      bulk100k: {
        title: "Bulk 100K",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      bulk250k: {
        title: "Bulk 250K",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      bulk750k: {
        title: "Bulk 750K",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      bulk1500k: {
        title: "Bulk 1.5M",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      bulk3M: {
        title: "Bulk 3M",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      bulk5M: {
        title: "Bulk 5M",
        description: {
          long: "For those that need a massive amount of shortened URLs for your SMS or other campaigns.",
          short: "for massive amounts of link shortening",
        },
      },
      enterprise: {
        title: "Enterprise",
        description: {
          long: "Need a larger limit, or custom-made solutions? Have a chat with our experts to design a tailor-made plan.",
          short: "for custom-made solutions.",
        },
      },
      "enterprise-free": {
        title: "Enterprise",
        description: {
          long: "Need a larger limit, or custom-made solutions? Have a chat with our experts to design a tailor-made plan.",
          short: "for custom-made solutions.",
        },
      },
      enterprise8M: {
        title: "Enterprise 8M",
        description: {
          long: "Need a larger limit, or custom-made solutions? Have a chat with our experts to design a tailor-made plan.",
          short: "for custom-made solutions.",
        },
      },
      enterprise15M: {
        title: "Enterprise 15M",
        description: {
          long: "Need a larger limit, or custom-made solutions? Have a chat with our experts to design a tailor-made plan.",
          short: "for custom-made solutions.",
        },
      },
      "domain-renewal-service": {
        title: "Domain Renewal Service",
        description: {
          long: "Required to enable purchased domains autorenewal functionality.",
          short: "for domain autorenewal processing.",
        },
      },
      intermediary: {
        title: "Intermediary",
        description: {
          long: "Required for migrating users from stripe to paddle.",
          short: "for stripe to paddle migration.",
        },
      },
      personal: {
        title: "Personal",
        description: {
          long: "Perfect for personal users that need access to detailed analytics and our link management dashboard.",
          short: "for users that need access detailed analytics and dashboard.",
        },
      },
      blackfriday2021: {
        title: "Black Friday",
        description: {
          long: "The plan customized for you on Black Friday, that includes link management, analytics, and using your own domains.",
        },
      },
      blackfriday2022: {
        title: "Black Friday",
        description: {
          long: "The plan customized for you on Black Friday, that includes link management, analytics, and using your own domains.",
        },
      },
      blackfriday2023: {
        title: "Black Friday",
        description: {
          long: "The plan customized for you on Black Friday, that includes link management, analytics, and using your own domains.",
        },
      },
      blackfriday2024: {
        title: "Black Friday",
        description: {
          long: "The plan customized for you on Black Friday, that includes link management, analytics, and using your own domains.",
        },
      },
      "paddle-plan-upgrade": {
        title: "Subscription Plan Change",
        description: {
          short: "Subscription upgrade service.",
          long: "Subscription upgrade service.",
        },
      },
    },
  },

  kiosk: {
    users: "Users",
    aliases: "TinyURL Management",
    longUrls: "Long URLs Management",
    tinyurlStats: "Analytics",
    accessInvitations: "Access Invitation",
    password_dictionary: "Passwords dictionary",
    ips: "IP Addresses",
    cloudflareZones: "Cloudflare Zones",
    announcements: "Announcements",
    metrics: "Metrics",
    systemStats: "System Stats",
    banned_domains: "Banned Domains Management",
    tld_overprice: "TLD overprice",
    overages: "Overage Cycles",
    domains: "Domains Management",
    surveys: "Surveys Management",
  },
};
